import * as urlUtils from 'utils/Url';
import constants from 'Constants';
import { getAuth, patchAuth, postAuth, deleteAuth } from 'api/Utils';


export function getViewControlManageConnections(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/control/manage-connections`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function postControlResyncConnections(successCallback, errorCallback, connectionId) {
  postAuth({
    "path": `control/connections/${connectionId}/resync`,
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function deleteControlConnections(successCallback, errorCallback, connectionId) {
  deleteAuth({
    "path": `control/connections/${connectionId}`,
    "successCallback": successCallback,
    "errorCallback": errorCallback,
  });
}

